<template>
    <sa-page-layout :btnRefreshVisible="true" @refresh="onRefresh" :showModalLoading="showModalLoading">
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Codice Fiscale Operatore</label>
                        <b-form-input v-model="filtro.codiceFiscaleOperatore" type="search" placeholder="Codice Fiscale"></b-form-input>
                    </b-col>
                    <b-col xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Stato</label>
                        <b-form-select v-model="filtro.stato" :options="opzioniStato"></b-form-select>
                    </b-col>
                    <!-- </b-row>
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem" class="mt-2"> -->
                    <b-col xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">ASL</label>
                        <b-form-select v-model="filtro.codiceAsl" :options="opzioniAslFiltro" @change="onCambiaAslFiltro"></b-form-select>
                    </b-col>
                    <b-col xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Distretto</label>
                        <b-form-select v-model="filtro.codiceDistretto" :options="opzioniDistrettoFiltro" :disabled="!filtro.codiceAsl || caricamentoDistrettiFiltro || !distrettiFiltro.length"></b-form-select>
                        <!-- <small class="text-muted">Con ASL o distretto scelti compaiono solo gli operatori con un'utenza collegata ai distretti.</small> -->
                    </b-col>
                </b-row>
                <b-row style="padding-top: 10px; padding-bottom: 10px">
                    <b-col class="sa-padding-right text-right">
                        <b-button variant="outline-info" @click="onClickSincronizza">
                            <i class="fas fa-cloud-download-alt"></i>
                            Aggiorna da AnDIamo
                        </b-button>
                        <b-button variant="success" @click="$refs.modalCrea.apri()">
                            <b-icon icon="plus"></b-icon>
                            Nuovo Utente
                        </b-button>
                        <b-button type="submit" variant="info">Cerca</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">Reset Filtro</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-header">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>Totale Record: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </template>
        <template slot="table-body">
            <div class="b-table-sticky-header">
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
                    <template v-slot:cell(nominativo)="{ item }">
                        <div class="font-weight-bold">{{ item.cognome }} {{ item.nome }}</div>
                        <small class="text-muted">CF: {{ item.codiceFiscaleOperatore }}</small>
                    </template>
                    <template v-slot:cell(ruolo)="{ item }">
                        <span class="badge badge-outline-primary border border-primary text-primary px-2">{{ item.tipoOperatoreDisplay || item.tipoOperatoreCode || "-" }}</span>
                    </template>
                    <template v-slot:cell(stato)="{ item }">
                        <span class="badge badge-pill badge-light border sa-siat-badge" :class="'sa-siat-badge-' + (item.stato === 'ATTIVO' ? 'aperta' : 'da-programmare')">{{ item.stato }}</span>
                    </template>
                    <template v-slot:cell(contatti)="{ item }">{{ item.telefono || "-" }} / {{ item.email || "-" }}</template>
                    <template v-slot:cell(periodo)="{ item }">{{ formatDate(item.dataInizio) }} - {{ item.dataFine ? formatDate(item.dataFine) : "in corso" }}</template>
                    <template v-slot:cell(actions)="{ item }">
                        <router-link :to="'/andiamo/utenti/' + item.codiceFiscaleOperatore + '/view'" class="btn btn-sm btn-outline-secondary mr-1">
                            <i class="fas fa-eye"></i>
                        </router-link>
                        <b-button v-if="item.stato === 'ATTIVO'" size="sm" variant="outline-danger" class="mr-1" @click="onClickDisattiva(item)">
                            <i class="fas fa-user-slash"></i>
                        </b-button>
                        <b-button v-else size="sm" variant="outline-success" @click="onClickRiattiva(item)">
                            <i class="fas fa-user-check"></i>
                        </b-button>
                        <b-button size="sm" variant="outline-primary" class="ml-1" :disabled="item.utenzaEsistente || item.stato !== 'ATTIVO'" :title="titoloPulsanteUtenza(item)" @click="onClickCreaUtenza(item)">
                            <i class="fas fa-user-plus"></i>
                        </b-button>
                        <b-button size="sm" variant="outline-secondary" class="ml-1" :disabled="!item.utenzaEsistente" :title="item.utenzaEsistente ? 'Associa distretti' : 'Crea prima l\'utenza'" @click="onClickDistretti(item)">
                            <i class="fas fa-map-marked-alt"></i>
                        </b-button>
                    </template>
                </b-table>
            </div>
            <no-data-component v-if="!items.length" title="Nessun utente locale: aggiorna da AnDIamo o modifica i filtri" :fontSize="15" :paddingSize="0.5" />
        </template>
        <template slot="table-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>Totale Record: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
            <AndiamoUtenteCreaModalComponent ref="modalCrea" @creato="loadData" />

            <b-modal ref="modalUtenza" title="Crea utenza gestionale" ok-title="Crea utenza" cancel-title="Annulla" :ok-disabled="!usernameProposto" @ok.prevent="confermaCreaUtenza">
                <p class="mb-2">
                    Operatore: <b>{{ utenteSelezionato ? utenteSelezionato.cognome + " " + utenteSelezionato.nome : "" }}</b> ({{ utenteSelezionato ? utenteSelezionato.tipoOperatoreDisplay : "" }})
                </p>
                <label class="sa-label-data">Username</label>
                <b-form-input v-model="usernameProposto" autofocus />
                <small class="text-muted">La password è generata automaticamente e inviata a {{ utenteSelezionato ? utenteSelezionato.email : "" }}.</small>
            </b-modal>

            <b-modal ref="modalDistretti" title="Associa distretti" size="lg" ok-title="Salva" cancel-title="Annulla" @ok.prevent="salvaDistretti">
                <div class="alert alert-light border mb-3 py-2">
                    <i class="fas fa-user mr-1"></i>
                    Operatore: <b>{{ utenteDistretti ? utenteDistretti.cognome + " " + utenteDistretti.nome : "" }}</b>
                    <span class="text-muted">({{ utenteDistretti ? utenteDistretti.usernameGestionale : "" }})</span>
                </div>
                <!-- Un tab per ASL, uno alla volta, con le convenzioni del progetto (sa-tab, fill, titoli sa-tab-title-*).
                     La selezione e' unica (distrettiSelezionati): cambiando tab non si perde nulla. Il titolo diventa verde
                     con la spunta quando l'ASL ha almeno un distretto selezionato e mostra quanti sono su quanti. -->
                <b-tabs v-if="gruppiAslDistretti.length" v-model="tabAslAttiva" content-class="mt-3" class="sa-tab" fill>
                    <b-tab v-for="gruppo in gruppiAslDistretti" :key="gruppo.chiave">
                        <template #title>
                            <div :class="selezionatiAsl(gruppo) ? 'sa-tab-title-success' : 'sa-tab-title-normal'">
                                <div v-if="selezionatiAsl(gruppo)" style="float: left">
                                    <b-icon icon="check"></b-icon>
                                </div>
                                <div style="float: left">
                                    <span>{{ gruppo.nome }} ({{ selezionatiAsl(gruppo) }}/{{ gruppo.distretti.length }})</span>
                                </div>
                            </div>
                        </template>
                        <div class="sa-distretti-elenco">
                            <div v-for="d in gruppo.distretti" :key="d.value" class="sa-distretto-riga" :class="{ 'sa-distretto-riga-attiva': distrettiSelezionati.includes(d.value) }">
                                <b-form-checkbox v-model="distrettiSelezionati" :value="d.value">
                                    <span class="d-flex align-items-start">
                                        <span class="badge badge-outline-primary border border-primary text-primary px-2 sa-distretto-codice">{{ d.codice }}</span>
                                        <span class="sa-distretto-descrizione">{{ d.descrizione }}</span>
                                    </span>
                                </b-form-checkbox>
                            </div>
                        </div>
                    </b-tab>
                </b-tabs>
                <div v-else class="text-muted">Nessun distretto disponibile</div>
                <div class="text-right small text-muted mt-2">{{ distrettiSelezionati.length }} distretti selezionati in totale</div>
            </b-modal>
        </template>
    </sa-page-layout>
</template>

<script>
import axios from "axios";
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import NoDataComponent from "../../../template/components/utility/NoDataComponent.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import AndiamoMixin from "../mixins/AndiamoMixin";
import AndiamoUtenteCreaModalComponent from "../components/AndiamoUtenteCreaModalComponent.vue";

export default {
    components: { SaPageLayout, NoDataComponent, AndiamoUtenteCreaModalComponent },
    mixins: [UtilityMixin, AndiamoMixin],
    data() {
        return {
            rows: 0,
            perPage: 2000,
            currentPage: 1,
            showModalLoading: false,
            items: [],
            opzioniStato: [
                { value: null, text: "Tutti" },
                { value: "ATTIVO", text: "ATTIVO" },
                { value: "DISATTIVATO", text: "DISATTIVATO" },
            ],
            filtro: { codiceFiscaleOperatore: null, stato: null, codiceAsl: null, codiceDistretto: null },
            // AnDIamo e' la piattaforma della Regione Campania: le ASL del filtro sono quelle della regione 150.
            codiceRegioneFiltro: "150",
            opzioniAslFiltro: [{ value: null, text: "Tutte le ASL" }],
            // Distretti dell'ASL scelta nel filtro: si caricano solo alla scelta dell'ASL.
            distrettiFiltro: [],
            caricamentoDistrettiFiltro: false,
            // Numera le richieste di distretti: una risposta arrivata in ritardo (ASL cambiata nel frattempo) si scarta.
            richiestaDistrettiFiltro: 0,
            fields: [
                { label: "Nominativo", key: "nominativo" },
                { label: "Ruolo", key: "ruolo" },
                { label: "Stato", key: "stato" },
                { label: "Contatti", key: "contatti" },
                { label: "Periodo", key: "periodo" },
                { label: "", key: "actions", tdClass: "sa-table-column-action-double" },
            ],
            utenteSelezionato: null,
            usernameProposto: "",
            utenteDistretti: null,
            opzioniDistretti: [],
            distrettiSelezionati: [],
            tabAslAttiva: 0,
        };
    },
    computed: {
        // Distretti selezionabili nel filtro: solo quelli dell'ASL scelta, gia' caricati. Il primo elemento
        // spiega lo stato del select (nessuna ASL / caricamento / nessun distretto / nessun filtro).
        opzioniDistrettoFiltro() {
            let segnaposto;
            if (!this.filtro.codiceAsl) {
                segnaposto = "Seleziona prima l'ASL";
            } else if (this.caricamentoDistrettiFiltro) {
                segnaposto = "Caricamento...";
            } else if (!this.distrettiFiltro.length) {
                segnaposto = "Nessun distretto per questa ASL";
            } else {
                segnaposto = "Tutti i distretti";
            }
            return [{ value: null, text: segnaposto }].concat(this.distrettiFiltro);
        },
        // Un gruppo (= un tab) per ASL, nell'ordine di opzioniDistretti (gia' ordinate per ASL e codice).
        // Dipende solo dall'elenco e non dalla selezione: spuntare un distretto non rigenera le opzioni.
        gruppiAslDistretti() {
            let gruppi = [];
            let perChiave = {};
            this.opzioniDistretti.forEach((o) => {
                if (!perChiave[o.aslChiave]) {
                    perChiave[o.aslChiave] = { chiave: o.aslChiave, nome: o.aslNome, distretti: [] };
                    gruppi.push(perChiave[o.aslChiave]);
                }
                perChiave[o.aslChiave].distretti.push({ value: o.value, codice: o.codice, descrizione: o.descrizione });
            });
            return gruppi;
        },
    },
    mounted() {
        this.caricaOpzioniFiltro();
        this.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.andiamoUtentiLocaliPathResource;
            let params = { ...me.filtro, page: me.currentPage, forPage: me.perPage };
            axios
                .get(link, { params: params })
                .then((response) => {
                    me.items = response.data.data.list || [];
                    me.rows = response.data.data.recordsNumber || 0;
                    me.showModalLoading = false;
                })
                .catch(() => {
                    me.showModalLoading = false;
                });
        },
        /**
         * Opzioni del filtro ASL: le ASL della regione (valore a 6 cifre = codice regione + codice azienda,
         * come la query del backend). I distretti NON si caricano qui: arrivano quando si sceglie l'ASL.
         */
        caricaOpzioniFiltro() {
            let me = this;
            axios
                .get(process.env.VUE_APP_PATH_API + "/asl/regione", { params: { codiceRegione: me.codiceRegioneFiltro } })
                .then((response) => {
                    let lista = (response.data.data || [])
                        .map((a) => ({
                            value: a.codiceRegione + a.codiceAzienda,
                            text: a.denominazione || "ASL " + a.codiceRegione + a.codiceAzienda,
                            codiceRegione: a.codiceRegione,
                            codiceAsl: a.codiceAzienda,
                        }))
                        .sort((x, y) => x.value.localeCompare(y.value));
                    me.opzioniAslFiltro = [{ value: null, text: "Tutte le ASL" }].concat(lista);
                })
                .catch(() => {});
        },
        // Quanti distretti di questa ASL sono spuntati (numero nel titolo del tab).
        selezionatiAsl(gruppo) {
            return gruppo.distretti.filter((d) => this.distrettiSelezionati.includes(d.value)).length;
        },
        /**
         * Scelta dell'ASL nel filtro: azzera il distretto (poteva appartenere all'ASL precedente) e carica SOLO
         * i distretti di quella ASL. Con "Tutte le ASL" (valore null) non parte nessuna richiesta.
         */
        onCambiaAslFiltro(valore) {
            let me = this;
            me.filtro.codiceDistretto = null;
            me.distrettiFiltro = [];
            let richiesta = ++me.richiestaDistrettiFiltro;
            let asl = me.opzioniAslFiltro.find((o) => o.value === valore && o.value !== null);
            if (!asl) {
                me.caricamentoDistrettiFiltro = false;
                return;
            }
            me.caricamentoDistrettiFiltro = true;
            axios
                .get(process.env.VUE_APP_PATH_API + "/distretti", { params: { codiceRegione: asl.codiceRegione, codiceAsl: asl.codiceAsl, forPage: 1000, page: 1 } })
                .then((response) => {
                    if (richiesta !== me.richiestaDistrettiFiltro) {
                        return;
                    }
                    me.distrettiFiltro = (response.data.data.list || []).map((d) => ({ value: d.codiceDistretto, text: d.codiceDistretto + " - " + d.descrizione })).sort((x, y) => x.value.localeCompare(y.value, undefined, { numeric: true }));
                    me.caricamentoDistrettiFiltro = false;
                })
                .catch(() => {
                    if (richiesta === me.richiestaDistrettiFiltro) {
                        me.caricamentoDistrettiFiltro = false;
                    }
                });
        },
        onSubmit() {
            this.currentPage = 1;
            this.loadData();
        },
        onReset() {
            this.filtro = { codiceFiscaleOperatore: null, stato: null, codiceAsl: null, codiceDistretto: null };
            this.onCambiaAslFiltro(null);
            this.currentPage = 1;
            this.loadData();
        },
        onRefresh() {
            this.loadData();
        },
        onClickSincronizza() {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.andiamoUtentiPathResource;
            axios
                .get(link, { params: {} })
                .then(() => {
                    me.showModalLoading = false;
                    me.$bvToast.toast("Utenti attivi aggiornati da AnDIamo", { title: "", variant: "success", solid: true });
                    me.loadData();
                })
                .catch((error) => {
                    me.showModalLoading = false;
                    me.$bvToast.toast("Errore: " + (error?.response?.data?.messaggio || error.message), { title: "Errore", variant: "danger", solid: true });
                });
        },
        onClickDisattiva(utente) {
            this.$bvModal.msgBoxConfirm("Disattivare l'utente " + utente.codiceFiscaleOperatore + "?", { title: "Conferma", okVariant: "danger" }).then((conferma) => {
                if (conferma) {
                    this.andiamoDisattivaUtente(utente.codiceFiscaleOperatore, null, null, () => {
                        this.$bvToast.toast("Utente disattivato", { title: "", variant: "success", solid: true });
                        this.loadData();
                    });
                }
            });
        },
        onClickRiattiva(utente) {
            let oggi = new Date().toISOString().slice(0, 10);
            let body = {
                codiceFiscaleOperatore: utente.codiceFiscaleOperatore,
                nome: utente.nome,
                cognome: utente.cognome,
                telefono: utente.telefono,
                email: utente.email,
                gender: utente.gender,
                tipoOperatoreCode: utente.tipoOperatoreCode,
                tipoOperatoreDisplay: utente.tipoOperatoreDisplay,
                dataInizio: oggi,
                dataFine: null,
            };
            this.andiamoInserisciUtente(body, () => {
                this.$bvToast.toast("Utente riattivato", { title: "", variant: "success", solid: true });
                this.loadData();
            });
            // this.andiamoModificaUtente(utente.codiceFiscaleOperatore, body, () => {
            //     this.$bvToast.toast("Utente riattivato", { title: "", variant: "success", solid: true });
            //     this.loadData();
            // });
        },
        proponiUsername(utente) {
            let normalizza = (t) =>
                (t || "")
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                    .toLowerCase()
                    .replace(/[^a-z0-9]/g, "");
            return normalizza(utente.nome) + "." + normalizza(utente.cognome);
        },
        titoloPulsanteUtenza(item) {
            if (item.utenzaEsistente) return "Utenza già creata: " + item.usernameGestionale;
            if (item.stato !== "ATTIVO") return "Operatore non attivo";
            return "Crea utenza nel gestionale";
        },
        onClickCreaUtenza(utente) {
            this.utenteSelezionato = utente;
            this.usernameProposto = utente.usernameGestionale || this.proponiUsername(utente);
            this.$refs.modalUtenza.show();
        },
        confermaCreaUtenza() {
            this.showModalLoading = true;
            this.andiamoCreaUtenzaGestionale(
                this.utenteSelezionato.codiceFiscaleOperatore,
                this.usernameProposto.trim(),
                (response) => {
                    this.showModalLoading = false;
                    this.$refs.modalUtenza.hide();
                    this.$bvToast.toast(response.data.messaggio || "Utenza creata", { title: "", variant: "success", solid: true });
                    this.loadData();
                },
                (error) => {
                    this.showModalLoading = false;
                    this.$bvToast.toast(error?.response?.data?.messaggio || error.message, { title: "Utenza non creata", variant: "danger", solid: true });
                },
            );
        },
        onClickDistretti(utente) {
            let me = this;
            me.utenteDistretti = utente;
            me.showModalLoading = true;
            let base = process.env.VUE_APP_PATH_API;
            Promise.all([
                axios.get(base + "/distretti", { params: { forPage: 1000, page: 1 } }),
                axios.get(base + "/distrettiutenti", { params: { idUtente: utente.idUtente, forPage: 1000, page: 1 } }),
                // se l'elenco ASL non risponde la modale funziona lo stesso, mostrando il solo codice
                axios.get(base + "/asl").catch(() => ({ data: { data: [] } })),
            ])
                .then(([distretti, associati, asl]) => {
                    // ASL = (codiceRegione, codiceAzienda), come il vincolo univoco dei distretti.
                    // Si accetta anche il codice ASL a 6 cifre (regione+azienda, es. 150206).
                    let nomiAsl = {};
                    (asl.data.data || []).forEach((a) => {
                        nomiAsl[a.codiceRegione + "|" + a.codiceAzienda] = a.denominazione;
                        nomiAsl[a.codiceRegione + a.codiceAzienda] = a.denominazione;
                    });
                    let nomeAsl = (d) => nomiAsl[d.codiceRegione + "|" + d.codiceAsl] || nomiAsl[d.codiceAsl] || "ASL " + d.codiceAsl;
                    let lista = (distretti.data.data.list || []).map((d) => ({
                        value: d.codiceDistretto,
                        codice: d.codiceDistretto,
                        descrizione: d.descrizione,
                        aslChiave: d.codiceRegione + "|" + d.codiceAsl,
                        aslNome: nomeAsl(d),
                    }));
                    lista.sort((a, b) => a.aslNome.localeCompare(b.aslNome) || a.value.localeCompare(b.value));
                    me.opzioniDistretti = lista;
                    let selezionati = (associati.data.data.list || []).map((a) => a.codiceDistretto);
                    me.distrettiSelezionati = selezionati;
                    // Si apre il tab della prima ASL che ha gia' distretti associati all'operatore (altrimenti il primo).
                    // L'ordine dei tab e' quello di prima apparizione dell'ASL in "lista" (computed gruppiAslDistretti).
                    let ordineAsl = [...new Set(lista.map((o) => o.aslChiave))];
                    let primaConSelezione = ordineAsl.findIndex((k) => lista.some((o) => o.aslChiave === k && selezionati.includes(o.value)));
                    me.tabAslAttiva = primaConSelezione >= 0 ? primaConSelezione : 0;
                    me.showModalLoading = false;
                    me.$refs.modalDistretti.show();
                })
                .catch((error) => {
                    me.showModalLoading = false;
                    me.$bvToast.toast("Errore nel caricamento dei distretti: " + (error?.response?.data?.messaggio || error.message), { title: "Errore", variant: "danger", solid: true });
                });
        },
        salvaDistretti() {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + "/distrettiutenti/utente/" + encodeURIComponent(me.utenteDistretti.idUtente);
            axios
                .put(link, { codiciDistretto: me.distrettiSelezionati })
                .then((response) => {
                    me.showModalLoading = false;
                    me.$refs.modalDistretti.hide();
                    me.$bvToast.toast(response.data.messaggio || "Distretti aggiornati", { title: "", variant: "success", solid: true });
                })
                .catch((error) => {
                    me.showModalLoading = false;
                    me.$bvToast.toast(error?.response?.data?.messaggio || error.message, { title: "Distretti non aggiornati", variant: "danger", solid: true });
                });
        },
    },
};
</script>

<style scoped>
.sa-siat-card-pratica {
    border: none;
    border-radius: 12px;
    margin-bottom: 20px;
    overflow: hidden;
}
.sa-siat-card-header-custom {
    background: #fff;
    border-bottom: 1px solid #edf2f7;
    padding: 15px 20px;
}
.sa-siat-label-pai {
    font-weight: bold;
    color: #7f8c8d;
    text-transform: uppercase;
    font-size: 0.85rem;
}
.sa-siat-badge {
    display: inline-block;
    font-size: 0.9rem;
}
.sa-siat-badge-aperta {
    color: #07af07;
}
.sa-siat-badge-da-programmare {
    color: #e67e22;
}
/* Modale "Associa distretti": elenco scorrevole e righe selezionabili */
.sa-distretti-elenco {
    max-height: 45vh;
    overflow-y: auto;
    border: 1px solid #edf2f7;
    border-radius: 6px;
}
.sa-distretto-riga {
    padding: 8px 12px;
    border-bottom: 1px solid #edf2f7;
    transition: background 0.15s;
}
.sa-distretto-riga:last-child {
    border-bottom: none;
}
.sa-distretto-riga:hover {
    background: var(--bg-sidebar-item);
}
.sa-distretto-riga-attiva {
    background: rgba(40, 167, 69, 0.08);
}
/* Codice a larghezza fissa e descrizione che, andando a capo, resta allineata al proprio testo */
.sa-distretto-codice {
    flex: 0 0 auto;
    min-width: 2.4rem;
    margin-top: 2px;
    margin-right: 0.6rem;
    text-align: center;
}
.sa-distretto-descrizione {
    flex: 1 1 auto;
}
</style>
